import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  FlexDirection,
  JustifyContent,
  Link,
  Space,
  Text,
} from '@gousto-internal/citrus-react'

import configRoutes from 'config/routes'
import { checkoutConfig } from 'routes/Checkout/checkoutConstants'

export const TermsAndConditions = () => (
  <Box
    display="flex"
    flexDirection={FlexDirection.Column}
    justifyContent={JustifyContent.Center}
    alignItems={AlignItems.Center}
  >
    <Space size={[4, 6]} direction="vertical" />
    <Text size={1}>{checkoutConfig.terms}</Text>
    <Text>
      <Link
        href={configRoutes.client.termsAndConditions}
        color={Color.Secondary_400}
        target="_blank"
      >
        {checkoutConfig.termsLinkText}
      </Link>
    </Text>
  </Box>
)
